import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fullscreen-loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_main_menu = _resolveComponent("main-menu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_loading, null, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("Loading...", -1)
          ]))]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass({ 'select-disable': _ctx.globalSelectDisable })
      }, [
        _createVNode(_component_main_menu),
        _createVNode(_component_router_view)
      ], 2))
}